
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"d":"M4.68 13.489l2.802-1.237.699-.592 1.454 3.308 1.292-3.308.72.606 1.918.824c.024-.079.05-.148.078-.206.695-.292 1.318-.606 1.73-.713a5.76 5.76 0 001.844 2.508c.852-.662 1.47-1.508 1.903-2.502.444.088 1.013.28 1.48.396.4.83.411 2.81.39 4.026h-5.943c.015.544.01 1.107 0 1.676H4.233c-.073-2.3.061-3.94.446-4.786zm10.958-4.466c.837.114 2.449-.05 3.12-.347.026.441.033 1.298-.24 1.954-.128.31-.32.557-.516.747l1.578.037s-.158-1.276-.11-1.607c.647-4.53-5.207-4.53-4.56 0 .047.33-.11 1.607-.11 1.607l1.59-.038a2.2 2.2 0 01-.516-.746c-.214-.512-.256-1.145-.251-1.608l.015.001zm-8.093.63c-.087-.882-.105-1.505.163-2.387 1.018-.62 2.261.382 3.76.036.146.733.197 1.359.153 2.393 0 0 .583-.502.664-.93.083-.43-.071-2.337-.276-2.643-.825-1.224-3.864-1.263-4.768-.208-.244.285-.524 2.892-.259 3.239.266.347.563.5.563.5z","fill-opacity":".65","fill":"#000","fill-rule":"nonzero"}})])])
          )
        }
      }
    